<template>
  <div class="ch-steps">
    <div class="ch-item" v-for="(item,index) in steps" :key="index">
      <div class="ch-item-li" :class="active==index?'active':''">
        <div class="ch-step">{{index+1}}</div>
      </div>
      <div class="ch-item-label">{{item.label}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: Number,
    steps: Array,
  }
};
</script>

<style lang="less" scoped>
.ch-steps {
  display: flex;
  > .ch-item {
    flex: 1;
    > .ch-item-li {
      height: 5px;
      background-color: #cccccc;
      position: relative;
      > .ch-step {
        position: absolute;
        height: 32px;
        width: 32px;
        line-height: 32px;
        text-align: center;
        top: 0;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        border-radius: 16px;
        background-color: #cccccc;
        color: #ffffff;
        font-size: 16px;
        font-weight: bold;
      }
    }
    > .ch-item-li.active {
      background-color: #3984f7;
      > .ch-step {
        background-color: #3984f7;
      }
    }
    > .ch-item-label {
      margin-top: 35px;
      font-size: 14px;
      color: #333333;
      text-align: center;
    }
  }
}
</style>
